import React from "react";
import logo from "./logo.svg";
import "./App.css";
import { withRouter } from "react-router";
import { Switch } from "react-router-dom";
import { GuestRoute } from "services/GuestRoute";
import Login from "./containers/Login/Login";
import ForgotPassword from "./containers/ForgotPassword/ForgotPassword";
import { PrivateRoute } from "services/PrivateRouter";
import AccountInfo from "./containers/AccountInfo/AccountInfo.lazy";
import DataTransmission from "./containers/DataTransmission/DataTransmission.lazy";
import DetailDataTransmission from "./containers/DetailDataTransmission/DetailDataTransmission.lazy";
import UpdatePassword from "./containers/UpdatePassword/UpdatePassword.lazy";
import NotFoundPage from "./components/NotFoundPage/NotFoundPage";
import Components from "./containers/Components/Components";
import SuccessForgotPassword from "./containers/ForgotPassword/SuccessForgotPassword/SuccessForgotPassword";
import Loading from "./components/Loading/Loading";
import UpdatePasswordSuccess from "./containers/UpdatePassword/UpdatePasswordSuccess/UpdatePasswordSuccess.lazy";

function AppComponent() {
  return (
    <>
      <Loading />
      <Switch>
        <GuestRoute exact path="/auth/login" component={Login} />
        <GuestRoute exact path="/components" component={Components} />
        <GuestRoute
          exact
          path="/auth/forgot-password"
          component={ForgotPassword}
        />
        <GuestRoute
          exact
          path="/forgot-password/success"
          component={SuccessForgotPassword}
        />
        <GuestRoute
          exact
          path="/auth/forgot-password/:key"
          component={UpdatePasswordSuccess}
        />
        <PrivateRoute exact path="/account-info" component={AccountInfo} />
        <PrivateRoute
          exact
          path="/data-transmission"
          component={DataTransmission}
        />
        <PrivateRoute
          exact
          path="/data-transmission/detail/:transactionId/:createdAt"
          component={DetailDataTransmission}
        />
        <PrivateRoute
          exact
          path="/update-password"
          component={UpdatePassword}
        />
        <PrivateRoute exact path="*" component={DataTransmission} />

        <PrivateRoute component={NotFoundPage} />
        <GuestRoute component={NotFoundPage} />
      </Switch>
    </>
  );
}

const App = withRouter(AppComponent);
export { App };
